import React, { Component } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import './index.css'

class PSLFEmployerDetails extends Component {
    state = {
        opened: false
    }

    toggleState = () => {
        this.setState({ opened: !this.state.opened})
    }

    render() {
        const { employer, canOpen = true } = this.props
        return (
            <div>
                <div onClick={this.toggleState} className="toggle-employer-details">
                    <p><NavigateNextIcon className={`navigate-next employer-toggle ${this.state.opened ? "opened" : ""}`} />{ employer.employer_name }</p>
                </div>
                {
                    this.state.opened && canOpen &&
                    <div>
                        <span>Official Name: {employer.official_name || employer.employer_official_name}</span><br />
                        <span>Official Phone: {employer.official_phone || employer.employer_official_phone}</span><br />
                        <span>Official Email: {employer.official_email || employer.employer_official_email}</span><br />
                        <span>EIN: {employer.employer_fein || ""}</span>
                    </div>
                }
            </div>
        )
    }
}

export default PSLFEmployerDetails;
